import { TRAIN_INCIDENT_ALERT_TYPE } from '@rsos/base-constants/alertTypes';
import mapEmergencyTypeToAlertType from './mapEmergencyTypeToAlertType';

/**
 * Checks if the emergency_type, including the test, is part of the Train Incident alert type.
 * @param {string} emergencyType - name of the emergencyType
 * @param {boolean} excludeTest - if true, will ignore test versions of alerts
 * @return boolean
 */
const getIsTrainIncident = (emergencyType = '', excludeTest = false) => {
  const sanitizedType =
    !excludeTest && emergencyType?.startsWith('TEST_')
      ? emergencyType.replace('TEST_', '')
      : emergencyType;

  const alertType = mapEmergencyTypeToAlertType(sanitizedType);

  return alertType === TRAIN_INCIDENT_ALERT_TYPE;
};

export default getIsTrainIncident;
